<template>
  <div :class="['page-cs-down', {isPC: isPC}]">
    <div class="logo-wrap">
      <img src="./images/down-logo.png" alt="">
    </div>
    <div class="btn-wrap" v-if="!isPC">
      <button class="btn-down btn-t1 downloadButton" @click="dfClk">下载股拍APP</button>
      <button class="btn-down btn-t2" @click="goYyb" v-if="os !== 'ios'">源文件下载</button>
    </div>
    <div class="qrcode-wrap" v-else>
      <p class="desc">请使用手机扫码下载股拍APP</p>
      <div class="qr">
        <img v-if="qr" :src="qr" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import storeMixin from '../mixins/store'
import queryString from '@spero/spero-utils/src/helpers/queryString'
// import {ORIGIN_LINK} from '@spero/spero-utils/src/constants/origin-link'
const ZSLDURL = {
  test: 'test',
  preview: 'preview',
  production: 'pro'
}
export default {
  name: 'down',
  mixins: [storeMixin],
  data () {
    return {
      qr: ''
    }
  },
  methods: {
    dfClk () {},
    goYyb () {
      location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.spero.vision.vsnapp'
    },
    down () {
      const {channelCode, source, my_token, courseId: classId, openUrl} = queryString.query(location.search)
      switch (source) {
        case 'zsld': {
          let env = process.env.VUE_APP_ENV || 'test'
          const t = env === 'test' ? 'test&' : ''
          const zsUrl = `https://zhishi.news.cn/${ZSLDURL[env]}/zsldCourse/#/live?my_token=${my_token}&classId=${classId}`
          const url = openUrl ? decodeURIComponent(openUrl) : zsUrl
          const net = `https://spero-h5.secon.cn/go/cs.html?${t}url=${encodeURIComponent(url)}`
          this.openInstallInit(this.$route, {
            channelCode,
            openinstallLink: `${window.speroBridge.baseUrl}web?url=${encodeURIComponent(net)}`
          }, false)
        }
          break
        default: {
          this.openInstallInit(this.$route, {
            channelCode
          }, false)
        }
      }
      setTimeout(() => {
        !this.isPC && window.openinstall.wakeupOrInstall()
      }, 2000)
    },
    async getQrCode () {
      if (!this.isPC) {
        return
      }
      try {
        const {data: {code, data, message}} = await this.$rootApi.api(['qrcode'], {
          data: {
            message: location.href
          }
        })
        if (code === 0) {
          this.qr = data.data
        } else {
          throw message
        }
      } catch (e) {
        this.$toast(e.message || e)
      }
    }
  },
  created () {
    this.down()
  },
  watch: {
    loginCount: {
      immediate: true,
      handler: function (v) {
        if (v > 0) {
          this.getQrCode()
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.logo-wrap
  > img
    display block
    width 1.98rem
.btn-wrap
  width 3rem
  margin 1.1rem auto 0
  .btn-down
    display block
    width 3rem
    height .44rem
    &.btn-t1
      font-size .16rem
      color #333
      background #FFD500
      border-radius .22rem
    &.btn-t2
      margin-top .08rem
      font-size .15rem
      color #666
      background transparent
.qrcode-wrap
  font-size .12rem
  line-height .4rem
  .qr
    font-size 0
    text-align center
    height 1.2rem
    > img
      width 1.2rem
      height 1.2rem
.page-cs-down
  position absolute
  width 100%
  height 100%
  display flex
  flex-direction column
  padding .77rem 0 2.17rem
  justify-content center
  align-items center
  background url(./images/down-foot.png) center bottom / 100% auto no-repeat
  &.isPC
    padding 0
</style>
